import React from "react";

const StepContent2 = ({ previousData, onNext }) => {
  const [age, setAge] = React.useState("");

  const handleNext = () => {
    onNext({
      ...previousData,
      age
    });
  };

  return React.createElement(
    "div",
    { className: "step-content" },
    React.createElement("h2", null, "Шаг 2: Дополнительные данные"),
    React.createElement(
      "p",
      null,
      "Имя из предыдущего шага: ",
      React.createElement(
        "strong",
        null,
        (previousData && previousData.name) || "не заполнено"
      )
    ),
    React.createElement("input", {
      className: "step-input",
      type: "number",
      placeholder: "Ваш возраст",
      value: age,
      onChange: (e) => setAge(e.target.value)
    }),
    React.createElement(
      "button",
      {
        className: "step-button",
        onClick: handleNext,
        disabled: !age
      },
      "Далее"
    )
  );
};

export default StepContent2;


